// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebaseConfig : {
    apiKey: "AIzaSyCB3tSjMMF97Anxo_mzJB5pl6fjhIrSZ7k",
    authDomain: "oshop-jack.firebaseapp.com",
    databaseURL: "https://oshop-jack.firebaseio.com",
    projectId: "oshop-jack",
    storageBucket: "",
    messagingSenderId: "968057944719",
    appId: "1:968057944719:web:49bd2dcc3c7c2142"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
